import { useEffect } from "react";
import { useActiveScrollContainer } from "@/contexts/ScrollContainerContext";

/**
 * iOS scrolls to top when the user taps the status bar — the standard system
 * tap target. Capacitor surfaces that native tap as a `statusTap` window
 * event; web browsers never fire it, so this is a no-op outside the shell.
 * Scrolls whichever container currently owns scrolling (stack overlays claim
 * priority over tabs via the scroll-container registry), so it composes with
 * pull-to-refresh and overlay stacking instead of fighting them.
 */
export function useStatusTapScrollToTop() {
  const activeScrollContainer = useActiveScrollContainer();

  useEffect(() => {
    const handleStatusTap = () => {
      const target: Pick<HTMLElement, "scrollTo"> = activeScrollContainer ?? window;
      target.scrollTo({ top: 0, behavior: "smooth" });
    };
    window.addEventListener("statusTap", handleStatusTap);
    return () => window.removeEventListener("statusTap", handleStatusTap);
  }, [activeScrollContainer]);
}
